import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const reveal = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } },
};

export const Notices = () => {
  return (
    <section
      id="notices"
      data-testid="notices-section"
      className="mx-auto max-w-3xl scroll-mt-10 px-6 pt-6 pb-20 sm:pt-8 sm:pb-24"
    >
      {/* 01 — The Rebuild */}
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.4 }}
        className="mb-14"
        data-testid="notice-rebuild"
      >
        <div className="flex items-baseline gap-4">
          <span className="font-display text-sm font-semibold text-[#17726b]">
            01
          </span>
          <div className="h-px flex-1 bg-[#ececec]" />
          <span className="eyebrow">The Rebuild</span>
        </div>
        <h2 className="font-display mt-8 text-3xl font-bold leading-tight tracking-tight text-[#1a1a1a] sm:text-4xl">
          A new home for Azzaro, built from the ground up.
        </h2>
        <p className="font-body mt-6 text-lg leading-relaxed text-[#4a4a4a]">
          Our official website is being rebuilt entirely in-house. During this
          renewal, this page is the single verified home of Azzaro Resorts &amp;
          Spa online. For reservations and enquiries, please reach us directly
          using the verified details below.
        </p>
      </motion.div>

      {/* 02 — Important Notice (Fraud warning) */}
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.35 }}
        data-testid="notice-fraud"
      >
        <div className="flex items-baseline gap-4">
          <span className="font-display text-sm font-semibold text-[#17726b]">
            02
          </span>
          <div className="h-px flex-1 bg-[#ececec]" />
          <span className="eyebrow">Important Notice</span>
        </div>

        <div
          className="relative mt-8 overflow-hidden rounded-2xl bg-white shadow-[0_24px_70px_-30px_rgba(0,0,0,0.25)]"
          data-testid="fraud-card"
        >
          <div className="h-1.5 w-full bg-[#2ca8a0]" />
          <div className="p-8 sm:p-10">
            <div className="flex items-start gap-4">
              <span className="mt-0.5 flex h-11 w-11 flex-none items-center justify-center rounded-full bg-[#2ca8a0]/10 text-[#2ca8a0]">
                <ShieldAlert className="h-5 w-5" />
              </span>
              <div>
                <h3 className="font-display text-xl font-bold tracking-tight text-[#1a1a1a] sm:text-2xl">
                  Beware of fraudulent websites
                </h3>
                <p className="font-body mt-4 text-base leading-relaxed text-[#4a4a4a] sm:text-lg">
                  Several fraudulent websites have been falsely claiming to
                  represent Azzaro Resorts. Please do{" "}
                  <span className="font-semibold text-[#1a1a1a]">not</span> trust
                  any bookings, payments, or communications made through them.
                </p>
                <p className="font-body mt-4 text-base leading-relaxed text-[#4a4a4a] sm:text-lg">
                  Trust only the verified contact details listed on this page.
                  These are the sole official channels for Azzaro Resorts &amp;
                  Spa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Notices;
